define.alias("ember-drag-sort/components/drag-sort-list", "settings/components/drag-sort-list");